var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import classNames from 'classnames';
import { Accordion, AccordionDetails, AccordionSummary, List, ListItem, makeStyles, RadioButton, Typography, } from "../../../../index";
import { PmlCourseInfo } from "../../models/PmlCourseInfo";
import { clickableStyle } from "../../../../styles/index";
import { getThumbnailPath } from "../helpers/thumbnail-helper";
var useStyles = makeStyles(function (theme) { return ({
    root: {},
    summary: {
        height: 48,
        borderLeft: function (props) {
            return props.kind === 'KEYBOARD'
                ? "solid 4px " + theme.palette.apps.keyboard
                : "solid 4px " + theme.palette.apps.moral;
        },
    },
    item: {
        borderTop: function (props) {
            return props.kind === 'KEYBOARD' ? 'solid 2px #fff3cd' : 'solid 2px #cbf6cb';
        },
        padding: 0,
        width: '100%',
    },
    itemContent: {
        display: 'flex',
        alignItems: 'center',
        paddingLeft: theme.spacing(7),
        overflow: 'hidden',
    },
    thumbnailContainer: {
        width: 100,
        minWidth: 100,
        height: 56,
        margin: theme.spacing(1, 1.5, 1, 0),
        overflow: 'hidden',
    },
    thumbnail: {
        width: '100%',
    },
    radio: {
        marginLeft: 'auto',
    },
    clickable: __assign({}, clickableStyle(theme)),
}); });
/**
 * 情報活用の課題アコーディオンのコンポーネント
 */
export var PmlAssignmentAccordion = function (props) {
    var accordionId = props.accordionId, className = props.className, courses = props.courses, groupId = props.groupId, kind = props.kind, defaultOpen = props.defaultOpen, title = props.title, thumbnail = props.thumbnail, onSelectCourse = props.onSelectCourse;
    var classes = useStyles(props);
    var onClickList = function (event, id) {
        event.stopPropagation();
        var selectedCourse = (function () {
            if (groupId === id) {
                return new PmlCourseInfo({
                    id: id,
                    title: title,
                    thumbnail: getThumbnailPath(kind, id, thumbnail),
                });
            }
            var target = courses.find(function (course) { return course.id === id; });
            if (target) {
                return new PmlCourseInfo({
                    id: id,
                    title: target.title,
                    thumbnail: getThumbnailPath(kind, id, target.thumbnail),
                });
            }
        })();
        onSelectCourse(selectedCourse);
    };
    return (React.createElement(Accordion, { className: classNames(classes.root, className), id: accordionId, style: { boxShadow: 'none' }, defaultExpanded: defaultOpen },
        React.createElement(AccordionSummary, { className: classNames(classes.summary, classes.clickable), backgroundColor: '#FFFDEC' },
            title,
            groupId && (React.createElement(RadioButton, { value: groupId, className: classes.radio, onClick: function (event) { return onClickList(event, groupId); } }))),
        React.createElement(AccordionDetails, { style: { padding: 0 } },
            React.createElement(List, { disablePadding: true }, courses.map(function (course, index) {
                return (React.createElement(ListItem, { className: classes.item, disableGutters: true, key: index, onClick: function (event) { return onClickList(event, course.id); } },
                    React.createElement("div", { className: classes.itemContent },
                        course.thumbnail && (React.createElement("div", { className: classes.thumbnailContainer },
                            React.createElement("img", { className: classes.thumbnail, src: getThumbnailPath(kind, course.id, course.thumbnail) }))),
                        React.createElement(Typography, { variant: 'body2' }, course.title)),
                    React.createElement(RadioButton, { value: course.id, className: classes.radio })));
            })))));
};
